import { useRouter } from "vue-router";
import { mapGetters, mapActions } from "vuex";

import { XMarkIcon } from "@heroicons/vue/24/outline";
import { CategoryGrid } from "@/components/ui/display";

export default {
	name: "CategoryModal",
	components: {
		XMarkIcon,
		CategoryGrid,
	},
	props: {
		toggleCategoryModal: {
			type: Function,
			required: true,
		},
	},
	data() {
		return {
			isOpen: false,
		};
	},
	computed: {
		...mapGetters("languages", ["languages", "activeLanguage"]),
		...mapGetters("staticContent", ["getTranslations"]),
		...mapGetters("processes", ["categories", "apiStatus"]),
	},
	mounted() {
		this.$nextTick(() => {
			this.isOpen = true;
		});
	},
	methods: {
		...mapActions("languages", ["setActiveLanguage"]),

		selectLanguage(language) {
			this.selectedLanguage = language;
		},

		updateLanguage(language) {
			if (language.id === this.activeLanguage.id) {
				return;
			}

			this.setActiveLanguage({ activeLanguage: language });

			const currentRoute = this.$router.currentRoute.value;

			const newRoute = {
				...currentRoute,
				params: {
					...currentRoute.params,
					lang: language.two_digit_code,
				},
			};

			this.$router.push(newRoute);

			localStorage.setItem("activeLanguage", JSON.stringify(language));

			window.location.reload();
		},

		handleCategorySelected() {
			this.isOpen = false;

			setTimeout(() => {
				this.toggleCategoryModal();
			}, 250);
		},

		closeModal() {
			this.isOpen = false;

			setTimeout(() => {
				this.toggleCategoryModal();
			}, 250);
		},
	},
	setup() {
		const router = useRouter();
		return { router };
	},
};
